import SwaggerUI from 'swagger-ui-react'
import "swagger-ui-react/swagger-ui.css"
import appConfig from '../../Config/config'

const ApiDocumentation = () => {

    const apiPath = `${appConfig.backendApiUrl}/openapi.yaml`

    return (
        <>
            <SwaggerUI url={apiPath}/>
        </>
    )
}

export {ApiDocumentation}
